module.exports = __webpack_public_path__ + "img/wytwornia_papierow_wartosciowych.cd1d122f.png";